import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import WarningBox from '../WarningBox/WarningBox';

const WithdrawalMethodWarningBox = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = useSelector((state) => state.associates.user);
  const userWithdrawalMethod = user?.userWithdrawalMethod;
  const userEmail = user?.email;

  if (user?.needsUpdateBankAccount) {
    return (
      <div className='mb-3'>
        <WarningBox
          title={t('needsUpdateBankAccount.title')}
          subtitle={t('needsUpdateBankAccount.subtitle')}
        />
      </div>
    );
  }

  const wireMethod =
    user.withdrawalMethod === 'WIRE_INTERNATIONAL' || user.withdrawalMethod === 'WIRE_MEXICO';
  const cashOrCertificate =
    user.withdrawalMethod === 'CASH' || user.withdrawalMethod === 'CERTIFICATE';

  if (user?.advantageNetworkStatus !== 'APPROVED' && !userWithdrawalMethod) {
    return null;
  }

  if (userWithdrawalMethod && userWithdrawalMethod.isActive) {
    return null;
  }

  if (userWithdrawalMethod?.status === 'WAITING_FIRST_PAYMENT') return null;

  if (cashOrCertificate) {
    return null;
  }

  let title = '';
  let subtitle = '';
  let nextUrl = '';

  if (user.withdrawalMethod === 'STRIPE') {
    if (userWithdrawalMethod == null || userWithdrawalMethod.status === 'WAITING_USER_CREATION') {
      // user needs to complete the onboarding process
      title = t('noAccountAssociated.STRIPE.title');
      subtitle = t('noAccountAssociated.STRIPE.subtitle', { email: userEmail });
      nextUrl = null;
    } else if (userWithdrawalMethod?.status === 'PENDING_TOS_ACCEPTANCE') {
      // user needs to provide additional info for its connected account
      title = t('reviewConnectedAccountRequired.title');
      subtitle = t('reviewConnectedAccountRequired.subtitle');
      nextUrl = `/confirm-add-account/?id=${userWithdrawalMethod.userWithdrawalMethodId}`;
    } else if (userWithdrawalMethod?.status === 'PENDING_REVIEW') {
      title = t('accountBeingReviewed.title');
      subtitle = '';
      nextUrl = null;
    }
  }

  return (
    <div className='mb-3'>
      <WarningBox
        title={title}
        subtitle={
          <div>
            {subtitle}
            <span style={{ color: 'var(--color-primary)', textDecoration: 'underline' }}>
              {nextUrl ? t('here') : ''}
            </span>
            .
          </div>
        }
        onClick={() => {
          if (nextUrl.startsWith('https://')) {
            window.location.href = nextUrl;
          } else {
            history.push(nextUrl);
          }
        }}
      />
    </div>
  );
};

export default WithdrawalMethodWarningBox;
